import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { CATEGORIES, SHAYARI, FEATURED_POETS } from '../data/shayari';
import { useApp } from '../context/AppContext';

const Sidebar = () => {
  const { language } = useApp();
  const { categoryId } = useParams();

  const topShayaris = [...SHAYARI].sort((a, b) => b.likes - a.likes).slice(0, 5);

  return (
    <aside className="sidebar">
      {/* Categories Widget */}
      <div className="sidebar__widget">
        <h3 className="sidebar__widget-title">
          <span>🗂️</span> {language==='ur'?'زمرے':language==='hi'?'श्रेणियाँ':language==='es'?'Categorías':language==='fr'?'Catégories':'Categories'}
        </h3>
        <ul className="sidebar__cat-list">
          <li>
            <Link
              to="/"
              className={`sidebar__cat-item ${!categoryId ? 'sidebar__cat-item--active' : ''}`}
            >
              <span className="sidebar__cat-icon">🌟</span>
              <span className="sidebar__cat-name">{language==='ur'?'تمام شاعری':language==='hi'?'सभी शायरी':language==='es'?'Todos':language==='fr'?'Tous':'All Shayari'}</span>
              <span className="sidebar__cat-count">{SHAYARI.length}</span>
            </Link>
          </li>
          {CATEGORIES.map(cat => {
            const count = SHAYARI.filter(s => s.category === cat.id).length;
            return (
              <li key={cat.id}>
                <Link
                  to={`/category/${cat.id}`}
                  className={`sidebar__cat-item ${categoryId === cat.id ? 'sidebar__cat-item--active' : ''}`}
                  style={{ '--cat-color': cat.color }}
                >
                  <span className="sidebar__cat-icon">{cat.icon}</span>
                  <div className="sidebar__cat-info">
                    <span className="sidebar__cat-name">{cat.label}</span>
                    <span className="sidebar__cat-native">
                      {language === 'ur' ? cat.urdu : language === 'en' ? cat.label : cat.hindi}
                    </span>
                  </div>
                  <span className="sidebar__cat-count">{count}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>

      {/* Trending Widget */}
      <div className="sidebar__widget">
        <h3 className="sidebar__widget-title">
          <span>🔥</span> {language==='ur'?'ٹرینڈنگ شاعری':language==='hi'?'ट्रेंडिंग शायरी':language==='es'?'Tendencias':language==='fr'?'Tendances':'Trending Shayari'}
        </h3>
        <ol className="sidebar__trending">
          {topShayaris.map((s, i) => {
            const text = s[language] || s.hi;
            const firstLine = text.split('\n')[0];
            return (
              <li key={s.id} className="sidebar__trending-item">
                <span className="sidebar__trending-num">{i + 1}</span>
                <div className="sidebar__trending-content">
                  <p className={`sidebar__trending-text ${language === 'ur' ? 'urdu-text' : ''}`}
                    dir={language === 'ur' ? 'rtl' : 'ltr'}>
                    {firstLine.length > 50 ? firstLine.slice(0, 50) + '…' : firstLine}
                  </p>
                  <span className="sidebar__trending-likes">❤️ {s.likes.toLocaleString()}</span>
                </div>
              </li>
            );
          })}
        </ol>
      </div>

      {/* Poets Widget */}
      <div className="sidebar__widget">
        <h3 className="sidebar__widget-title">
          <span>✍️</span> {language==='ur'?'نمایاں شاعر':language==='hi'?'प्रसिद्ध शायर':language==='es'?'Poetas Destacados':language==='fr'?'Poètes en vedette':'Featured Poets'}
        </h3>
        <div className="sidebar__poets">
          {FEATURED_POETS.slice(0, 6).map(poet => (
            <Link to="/poets" key={poet.name} className="sidebar__poet">
              <div className="sidebar__poet-avatar">
                {poet.name.charAt(0)}
              </div>
              <div className="sidebar__poet-info">
                <span className="sidebar__poet-name">
                  {language === 'ur' ? poet.urdu : language === 'hi' ? poet.hindi : poet.name}
                </span>
                <span className="sidebar__poet-era">{poet.era}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Language Widget */}
      <div className="sidebar__widget sidebar__widget--lang">
        <h3 className="sidebar__widget-title">
          <span>🌐</span> {language==='ur'?'آج کا لفظ':language==='hi'?'आज का शब्द':language==='es'?'Palabra del Día':language==='fr'?'Mot du Jour':'Word of the Day'}
        </h3>
        <div className="sidebar__word">
          <div className="sidebar__word-urdu">محبت</div>
          <div className="sidebar__word-hindi">मोहब्बत (Mohabbat)</div>
          <div className="sidebar__word-meaning">
            {language==='ur'?'محبت • انسانی دل کا سب سے گہرا جذبہ':language==='hi'?'प्यार • इंसानी दिल का सबसे गहरा एहसास':language==='es'?'Amor • La emoción más profunda del corazón humano':language==='fr'?'Amour • L\'émotion la plus profonde du cœur humain':'Love • The deepest emotion known to the human heart'}
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
